<template>
  <v-sheet
    class="right-panel"
    :class="rightPanelTransitioning && 'transition-width'"
    :style="`width: ${panelWidth}px`"
  >
    <div class="header">
      <p>{{ title }}</p>
      <v-btn icon @click="closePanel">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
    <div class="content">
      <helpPanel v-if="isHelpOpen" />
      <changeHistory v-else-if="isChangeHistoryOpen" />
    </div>
  </v-sheet>
</template>
    
<script>
/**
 * @author Cameron Bulock <cameron.bulock@quavo.com>
 */

import { mapGetters } from "vuex";

import changeHistory from "@/components/change-history";
import helpPanel from "@/components/help-panel";

export default {
  name: "RightPanel",
  components: {
    changeHistory,
    helpPanel,
  },
  methods: {
    closePanel() {
      this.$store.dispatch("closeRightPanel");
    },
  },
  computed: {
    ...mapGetters({
      title: "getRightPanelTitle",
      panelWidth: "getRightPanelWidth",
      isChangeHistoryOpen: "getChangeHistoryOpen",
      isHelpOpen: "getHelpOpen",
      rightPanelTransitioning: "getRightPanelTransitioning",
    }),
  },
};
</script>
    
<style lang="scss" scoped>
.right-panel.right-panel {
  grid-area: right-panel;
  position: absolute;
  right: 0;
  height: 100%;
  box-shadow: $qvo-shadow-2;
  z-index: 100;
  padding-top: $qvo-spacing-24;
  display: flex;
  flex-direction: column;
  &.transition-width {
    transition: width 200ms;
  }
  .header {
    padding: 0 $qvo-spacing-24;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .content {
    height: 100%;
    overflow: auto;
  }
}
</style>